import { DialogComponent } from '@theme/dialog';

/**
 * Size guide dialog: extends the theme's DialogComponent with a cm/inches
 * unit toggle. Toggle state lives in a `data-units` attribute on the inner
 * <dialog> element; CSS shows/hides rows based on it.
 */
class SizeGuideDialog extends DialogComponent {
  /**
   * Switches the displayed unit and updates aria-pressed on the buttons.
   * Wired via `on:click="size-guide-dialog/selectUnit/cm"` (or `/in`).
   *
   * @param {string} units - 'cm' or 'in'
   */
  selectUnit = (units) => {
    if (units !== 'cm' && units !== 'in') return;

    const { dialog } = this.refs;
    if (!dialog) return;

    dialog.dataset.units = units;

    for (const btn of this.querySelectorAll('[data-unit-btn]')) {
      const pressed = btn.getAttribute('data-unit-btn') === units;
      btn.setAttribute('aria-pressed', String(pressed));
    }
  };
}

if (!customElements.get('size-guide-dialog')) {
  customElements.define('size-guide-dialog', SizeGuideDialog);
}
